import { render, staticRenderFns } from "./AppNotificationIcon.vue?vue&type=template&id=350ee340"
import script from "./AppNotificationIcon.vue?vue&type=script&lang=js"
export * from "./AppNotificationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports